'use strict';

angular.module('shiftTraderApp')
    .directive('saHomeSlide', ['$compile', '$state', 'NotesStore', 'TimeService', 'WorkPeriods', 'InternalAnalyticsService',
    function($compile, $state, NotesStore, TimeService, WorkPeriods, InternalAnalyticsService) {
      return {
        template: '<div class="slide_swipe"></div>',
        require: '^saHomeSlider',
        replace: true,
        link: function(scope, element, attr, ctrl) {
          scope.name = attr.identifier;
          scope.hasRendered = false;

          scope.todayDate = TimeService.getNowInStoreTime();

          var calcNextWorkPeriod = function () {
            if (angular.isDefined(scope.myWorkPeriods)) {
              if (scope.myWorkPeriods.length > 0) {
                var temp = _(scope.myWorkPeriods).where(function(wp) {
                  return wp.start_time >= scope.todayDate;
                }).sortBy(function(wp) {
                  return wp.start_time.unix();
                }).value();

                return temp[0];
              } else {
                return false;
              }

            } else {
              return undefined;
            }
          };

          function loadDayShifts() {
            var entireDay = TimeService.getDayTwixFromDate(scope.nextWorkPeriod.start_time);
            if (scope.myWorkPeriods.length > 0) {
              var temp = lodash(scope.myWorkPeriods).filter(function(wp) {
                return entireDay.contains(wp.start_time);
              }).sortBy(function(wp) {
                return wp.start_time.unix();
              }).value();

              return temp;
            } else {
              return [];
            }
          }

          // SATODO: THIS MUST BE REFACTORED... GROSS, GROSS DEPENDENCIES HERE.
          var startDateForWorkPeriodsQuery = moment(scope.todayDate).subtract(1, 'day').toISOString();
          WorkPeriods.getAll({
            user_id: scope.me.id,
            start_time: startDateForWorkPeriodsQuery
          })
            .then(function (data) {
              scope.gotNextWPData = true;
              scope.myWorkPeriods = lodash.filter(data, function(wp) {
                return wp.$isPublished();
              });
              scope.upcomingWorkPeriods = lodash.filter(scope.myWorkPeriods, function(wp) {
                return wp.start_time.isAfter(scope.todayDate);
              });
              scope.workingNowWorkPeriod = lodash.find(scope.myWorkPeriods, function(wp) {
                return wp.range_twix.contains(scope.todayDate) || wp.start_time.isSame(scope.todayDate);
              });
              scope.nextWorkPeriod = calcNextWorkPeriod();

              if (scope.nextWorkPeriod) {
                scope.dayShifts = loadDayShifts();
              }

              loadNotesForShift();

              if (angular.isDefined(scope.nextWorkPeriod) && scope.nextWorkPeriod !== false) {
                if (!_.isNull(scope.nextWorkPeriod.position.department_id) && !_.isUndefined(scope.allDepartments)) {
                  scope.nextWorkPeriod.position.department = _.find(scope.allDepartments, {id: scope.nextWorkPeriod.position.department_id});
                }
                scope.nextWorkPeriod._localStartTime = scope.nextWorkPeriod.start_time.format('dddd h:mm a on MMM D');
              }

              if (angular.isDefined(scope.workingNowWorkPeriod) && scope.workingNowWorkPeriod !== false) {
                if (!lodash.isNull(scope.workingNowWorkPeriod.position.department_id) && !lodash.isUndefined(scope.allDepartments)) {
                  scope.workingNowWorkPeriod.position.department = lodash.find(scope.allDepartments, {id: scope.workingNowWorkPeriod.position.department_id});
                }
                scope.workingNowWorkPeriod._localStartTime = scope.workingNowWorkPeriod.start_time.format('dddd h:mm a on MMM D');
              }

              InternalAnalyticsService.captureAnalytic('mbl_home_work_periods', {
                _v: 1,
                work_periods: lodash.map(data, function(wp) {
                  var x = lodash.find(scope.myWorkPeriods, {id: wp.id});
                  return {
                    id: wp.id,
                    time: wp.range_twix.format(),
                    published: wp.$isPublished(),
                    inMyWP: !lodash.isUndefined(x)
                  };
                }),
                dateToday: scope.todayDate.format(),
                startTimeInQuery: startDateForWorkPeriodsQuery,
                workingNowWorkPeriod: (lodash.isUndefined(scope.workingNowWorkPeriod) ? null : (
                {
                  id: scope.workingNowWorkPeriod.id,
                  time: scope.workingNowWorkPeriod.range_twix.format()
                }
                )),
                nextWorkPeriod: ((scope.nextWorkPeriod === false || lodash.isUndefined(scope.nextWorkPeriod)) ? null : (
                {
                  id: scope.nextWorkPeriod.id,
                  time: scope.nextWorkPeriod.range_twix.format()
                }
                ))

              });
            });

          function loadNotesForShift() {
            var mmnt = null;

            if (scope.dayShifts) {
              mmnt = TimeService.getBeginningOfDayFromDateWithOrgSetting(scope.dayShifts[0].start_time);
            } else {
              mmnt = TimeService.getBeginningOfDayFromDateWithOrgSetting(scope.todayDate);
            }

            scope.notesArr = [];
            lodash.each(scope.dayShifts, function(shift) {
              NotesStore.getNotesWithFilter({ obj: 'WorkPeriod', obj_id: shift.id })
                .then(function(notes) {
                  scope.notesArr = lodash.uniqBy(lodash.concat(scope.notesArr, notes), 'id');
                }, function(response) {
                  console.log('Failed to get Notes with Filter', response);
                });
            });

            var twx = TimeService.getDayTwixFromDate(mmnt);
            NotesStore.getNotesForTwix(twx)
              .then(function(notes) {
                notes = lodash.filter(notes, function(note) {
                  return lodash.some(note.notes_relations, function(rel) {
                    if (!rel.active) {
                      return false;
                    }

                    if (rel.obj === 'Position') {
                      return lodash.some(scope.dayShifts, {position_id: parseInt(rel.obj_id)});
                    } else if (rel.obj === 'WorkPeriod') {
                      return false;
                    } else {
                      return true;
                    }
                  });
                });

                scope.notesArr = lodash.uniqBy(lodash.concat(scope.notesArr, notes), 'id');
              }, function(response) {
                console.log('Failed to get Notes for Twix', response);
              });
          }

          scope.goToNextShiftStoreSchedule = function () {
            $state.go('storeSchedule.show', {date: scope.nextWorkPeriod.start_time.format('YYYY-MM-DD')});
          }

          scope.goToTodayStoreSchedule = function() {
            $state.go('storeSchedule.show', {date: scope.todayDate.format('YYYY-MM-DD')});
          };

          ctrl.registerSlide({
            element: element,
            scope: scope,
            name: scope.name
          });

          scope.goToShift = function(index) {
            $state.go('workPeriods.show', { workPeriodId: scope.dayShifts[index].id });
          };

          scope.$on('saHomeSlider:renderSlide' + attr.identifier, function() {
            if (!scope.hasRendered) {
              $(element).html($compile('<div ng-include="\'views/directives/saHomeSlide.html\'"></div>')(scope));
              scope.hasRendered = true;
            }
          });

        }
      };
    }]);
